import { ref } from 'vue'

export const headerLoading       = ref(false)
export const headerLastUpdate    = ref('')
export const headerCountdown     = ref(60)
export const headerMyCount       = ref(0)
export const headerMyOpenCount   = ref(0)
export const headerMyTeamFilter  = ref(false)
export const headerMyFluxosFilter = ref(false)

let _cbExport:    () => void = () => undefined
let _cbTestNotif: () => void = () => undefined

export function registerHeaderCallbacks(cbs: {
  onExport?:    () => void
  onTestNotif?: () => void
}) {
  if (cbs.onExport)    _cbExport    = cbs.onExport
  if (cbs.onTestNotif) _cbTestNotif = cbs.onTestNotif
}

export function headerEmitExport()    { _cbExport() }
export function headerEmitTestNotif() { _cbTestNotif() }
export function headerEmitToggle()    { headerMyTeamFilter.value = !headerMyTeamFilter.value }
export function headerEmitToggleFluxos() { headerMyFluxosFilter.value = !headerMyFluxosFilter.value }

// Fase 4.2 do plano de otimização de login (docs/planos/PLANO-OTIMIZACAO-LOGIN.md):
// chamado no logout — headerMyCount/headerMyOpenCount são contagens do agente
// que estava logado; headerMyTeamFilter/headerMyFluxosFilter são toggles de
// UI sem persistência própria. Sem isso, um agente B logando na mesma aba
// herdaria os números e os filtros ligados de A até o próximo ciclo de dados.
// Não mexe nos callbacks (_cbExport/_cbTestNotif) — são só wiring de UI,
// re-registrados pela view no próximo mount, não dado de sessão.
export function resetHeaderState(): void {
  headerLoading.value        = false
  headerLastUpdate.value     = ''
  headerCountdown.value      = 60
  headerMyCount.value        = 0
  headerMyOpenCount.value    = 0
  headerMyTeamFilter.value   = false
  headerMyFluxosFilter.value = false
}
